/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateOrganizationRequest } from '../model';
// @ts-ignore
import { OrganizationDetailResponse } from '../model';
// @ts-ignore
import { OrganizationListItemResponse } from '../model';
// @ts-ignore
import { UpdateOrganizationRequest } from '../model';
/**
 * OrgsApi - axios parameter creator
 * @export
 */
export const OrgsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates and provisions an organization. This operation is restricted to Organization.ADMIN users in the Mercatus organization. System field  provisioning is asynchronous and eventually consistent. 
         * @summary Create a new organization.
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (createOrganizationRequest: CreateOrganizationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrganizationRequest' is not null or undefined
            assertParamExists('createOrganization', 'createOrganizationRequest', createOrganizationRequest)
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get organization details by ID.
         * @param {number} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (orgId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrganization', 'orgId', orgId)
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only super administrators may update organization settings. For nullable non-secret stored fields other than integrationsEnabled and dbtJobId, omitting a field or setting it to null clears its existing value. For integrationsEnabled, omitting the field or setting it to null leaves the current integration state unchanged. Setting it to true provisions a Workato customer when one does not already exist; setting it to false is not supported after provisioning. For dbtJobId, omitting the field or setting it to null leaves existing DBT jobs unchanged, setting it to an empty or whitespace-only string clears all existing DBT jobs, and providing a non-empty value updates the jobs to the supplied list. For oauthAccessKey, powerBiClientSecretId, dbtWebhookKey, and dbtSecretKey, omitting a field retains its existing value, setting it to null clears the stored secret, and providing a value replaces it. powerUserLimit is required and must be zero or greater. 
         * @summary Update an organization.
         * @param {number} orgId Organization ID
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (orgId: number, updateOrganizationRequest: UpdateOrganizationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrganization', 'orgId', orgId)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganization', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/orgs/{orgId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgsApi - functional programming interface
 * @export
 */
export const OrgsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrgsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates and provisions an organization. This operation is restricted to Organization.ADMIN users in the Mercatus organization. System field  provisioning is asynchronous and eventually consistent. 
         * @summary Create a new organization.
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(createOrganizationRequest: CreateOrganizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(createOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get organization details by ID.
         * @param {number} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(orgId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(orgId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationListItemResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Only super administrators may update organization settings. For nullable non-secret stored fields other than integrationsEnabled and dbtJobId, omitting a field or setting it to null clears its existing value. For integrationsEnabled, omitting the field or setting it to null leaves the current integration state unchanged. Setting it to true provisions a Workato customer when one does not already exist; setting it to false is not supported after provisioning. For dbtJobId, omitting the field or setting it to null leaves existing DBT jobs unchanged, setting it to an empty or whitespace-only string clears all existing DBT jobs, and providing a non-empty value updates the jobs to the supplied list. For oauthAccessKey, powerBiClientSecretId, dbtWebhookKey, and dbtSecretKey, omitting a field retains its existing value, setting it to null clears the stored secret, and providing a value replaces it. powerUserLimit is required and must be zero or greater. 
         * @summary Update an organization.
         * @param {number} orgId Organization ID
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(orgId: number, updateOrganizationRequest: UpdateOrganizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(orgId, updateOrganizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrgsApi - factory interface
 * @export
 */
export const OrgsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrgsApiFp(configuration)
    return {
        /**
         * Creates and provisions an organization. This operation is restricted to Organization.ADMIN users in the Mercatus organization. System field  provisioning is asynchronous and eventually consistent. 
         * @summary Create a new organization.
         * @param {CreateOrganizationRequest} createOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(createOrganizationRequest: CreateOrganizationRequest, options?: any): AxiosPromise<OrganizationDetailResponse> {
            return localVarFp.createOrganization(createOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get organization details by ID.
         * @param {number} orgId Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(orgId: number, options?: any): AxiosPromise<OrganizationDetailResponse> {
            return localVarFp.getOrganization(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizations(options?: any): AxiosPromise<Array<OrganizationListItemResponse>> {
            return localVarFp.listOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * Only super administrators may update organization settings. For nullable non-secret stored fields other than integrationsEnabled and dbtJobId, omitting a field or setting it to null clears its existing value. For integrationsEnabled, omitting the field or setting it to null leaves the current integration state unchanged. Setting it to true provisions a Workato customer when one does not already exist; setting it to false is not supported after provisioning. For dbtJobId, omitting the field or setting it to null leaves existing DBT jobs unchanged, setting it to an empty or whitespace-only string clears all existing DBT jobs, and providing a non-empty value updates the jobs to the supplied list. For oauthAccessKey, powerBiClientSecretId, dbtWebhookKey, and dbtSecretKey, omitting a field retains its existing value, setting it to null clears the stored secret, and providing a value replaces it. powerUserLimit is required and must be zero or greater. 
         * @summary Update an organization.
         * @param {number} orgId Organization ID
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(orgId: number, updateOrganizationRequest: UpdateOrganizationRequest, options?: any): AxiosPromise<OrganizationDetailResponse> {
            return localVarFp.updateOrganization(orgId, updateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgsApi - object-oriented interface
 * @export
 * @class OrgsApi
 * @extends {BaseAPI}
 */
export class OrgsApi extends BaseAPI {
    /**
     * Creates and provisions an organization. This operation is restricted to Organization.ADMIN users in the Mercatus organization. System field  provisioning is asynchronous and eventually consistent. 
     * @summary Create a new organization.
     * @param {CreateOrganizationRequest} createOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public createOrganization(createOrganizationRequest: CreateOrganizationRequest, options?: any) {
        return OrgsApiFp(this.configuration).createOrganization(createOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get organization details by ID.
     * @param {number} orgId Organization ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public getOrganization(orgId: number, options?: any) {
        return OrgsApiFp(this.configuration).getOrganization(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all organizations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public listOrganizations(options?: any) {
        return OrgsApiFp(this.configuration).listOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only super administrators may update organization settings. For nullable non-secret stored fields other than integrationsEnabled and dbtJobId, omitting a field or setting it to null clears its existing value. For integrationsEnabled, omitting the field or setting it to null leaves the current integration state unchanged. Setting it to true provisions a Workato customer when one does not already exist; setting it to false is not supported after provisioning. For dbtJobId, omitting the field or setting it to null leaves existing DBT jobs unchanged, setting it to an empty or whitespace-only string clears all existing DBT jobs, and providing a non-empty value updates the jobs to the supplied list. For oauthAccessKey, powerBiClientSecretId, dbtWebhookKey, and dbtSecretKey, omitting a field retains its existing value, setting it to null clears the stored secret, and providing a value replaces it. powerUserLimit is required and must be zero or greater. 
     * @summary Update an organization.
     * @param {number} orgId Organization ID
     * @param {UpdateOrganizationRequest} updateOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgsApi
     */
    public updateOrganization(orgId: number, updateOrganizationRequest: UpdateOrganizationRequest, options?: any) {
        return OrgsApiFp(this.configuration).updateOrganization(orgId, updateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
